import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { ChallengeProgramSectionTitle } from '@lean-body/components/atoms';
import { MediaBreakPointUp } from '@lean-body/components/styles';
export const NextLessonDayHeader = (props) => {
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.subTitle) }, "NEXT LESSON"),
        React.createElement(ChallengeProgramSectionTitle, { title: `DAY ${props.day}` })));
};
const styles = StyleSheet.create({
    container: {
        [MediaBreakPointUp.MD]: {
            marginLeft: '1rem',
        },
    },
    title: {
        display: 'flex',
        flexFlow: 'column',
    },
    subTitle: {
        fontSize: '0.8rem',
        fontWeight: 500,
        color: '#979797',
        marginBottom: '2px',
    },
    sectionTitle: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
    },
});
